import { render, staticRenderFns } from "./founderStageThree.vue?vue&type=template&id=1953ef29"
import script from "./founderStageThree.vue?vue&type=script&lang=js"
export * from "./founderStageThree.vue?vue&type=script&lang=js"
import style0 from "./founderStageThree.vue?vue&type=style&index=0&id=1953ef29&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports